class ProductGallery extends HTMLElement {
  connectedCallback() {
    this.mainImage = this.querySelector('[data-gallery-main]');
    this.thumbs = this.querySelectorAll('[data-gallery-thumb]');
    // Only the image-gallery section has one; the product page gallery does not.
    this.caption = this.querySelector('[data-gallery-caption]');

    this.thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => this.select(thumb));
    });
  }

  select(thumb) {
    if (!this.mainImage || this.mainImage.tagName !== 'IMG') return;
    this.mainImage.src = thumb.dataset.fullSrc;
    this.mainImage.width = thumb.dataset.fullWidth;
    this.mainImage.height = thumb.dataset.fullHeight;
    this.mainImage.alt = thumb.dataset.fullAlt;
    if (this.caption && thumb.dataset.fullCaption) {
      this.caption.textContent = thumb.dataset.fullCaption;
    }
    this.thumbs.forEach((t) => t.classList.toggle('is-active', t === thumb));
  }
}

if (!customElements.get('product-gallery-component')) {
  customElements.define('product-gallery-component', ProductGallery);
}

class ProductForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.submitButton = this.querySelector('[data-add-to-cart]');
    this.labelEl = this.querySelector('[data-add-to-cart-label]');
    this.errorEl = this.querySelector('[data-product-form-error]');
    this.cartType = this.dataset.cartType;

    const quantityWrapper = this.querySelector('[data-quantity-input]');
    if (quantityWrapper) {
      const input = quantityWrapper.querySelector('[data-quantity-value]');
      quantityWrapper.querySelector('[data-quantity-increase]').addEventListener('click', () => {
        input.value = (Number(input.value) || 1) + 1;
      });
      quantityWrapper.querySelector('[data-quantity-decrease]').addEventListener('click', () => {
        input.value = Math.max(1, (Number(input.value) || 1) - 1);
      });
    }

    if (this.form) {
      this.form.addEventListener('submit', (event) => this.handleSubmit(event));
    }
  }

  async handleSubmit(event) {
    event.preventDefault();
    this.setLoading(true);
    this.hideError();

    try {
      const formData = new FormData(this.form);
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      });
      const data = await response.json();

      if (!response.ok) {
        this.showError(data.description || data.message);
        return;
      }

      if (window.MDockCart) {
        window.MDockCart.refresh({ openDrawer: this.cartType === 'drawer' });
      }
      if (this.cartType !== 'drawer') {
        window.location.href = this.dataset.cartUrl || '/cart';
      }
    } catch (error) {
      this.showError();
    } finally {
      this.setLoading(false);
    }
  }

  setLoading(isLoading) {
    if (this.submitButton) this.submitButton.disabled = isLoading;
    if (this.labelEl) this.labelEl.style.opacity = isLoading ? '0.6' : '1';
  }

  showError(message) {
    if (!this.errorEl) return;
    this.errorEl.textContent = message || this.errorEl.dataset.genericError || '';
    this.errorEl.hidden = false;
  }

  hideError() {
    if (!this.errorEl) return;
    this.errorEl.hidden = true;
  }
}

if (!customElements.get('product-form-component')) {
  customElements.define('product-form-component', ProductForm);
}

class QuickAddButton extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    if (this.button) this.button.addEventListener('click', () => this.add());
  }

  async add() {
    if (!this.button || this.button.disabled) return;
    this.button.disabled = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: this.dataset.variantId, quantity: 1 }),
      });

      if (response.ok && window.MDockCart) {
        window.MDockCart.refresh({ openDrawer: this.dataset.cartType === 'drawer' });
      }
    } finally {
      this.button.disabled = false;
    }
  }
}

if (!customElements.get('quick-add-button')) {
  customElements.define('quick-add-button', QuickAddButton);
}
